export default __webpack_public_path__ + "static/media/avalicao_e_monitoramento.09190f2d.pdf";